import { render, staticRenderFns } from "./AttributeCourse.vue?vue&type=template&id=054647b5"
import script from "./AttributeCourse.vue?vue&type=script&lang=js"
export * from "./AttributeCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports